var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"site-header w-full px-4 py-6 xl:py-8 xl-px-8 xxl:py-14 xxl:px-14 absolute top-0 z-10"},[_c('router-link',{attrs:{"to":"/"}},[_c('Logo',{staticClass:"w-16 xl:w-24 xxl:w-32"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }